import { Box, CircularProgress, Divider, FormHelperText, Typography } from '@mui/material';
import { FormikConfig } from 'formik';
import React from 'react';
import CollapsibleTable from '../../../components/CollapsibleTable/CollapsibleTable';
import FilterComponentV2 from '../../../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import TabsLayout from '../../../components/Tabs/TabsLayout';
import { getGemiBoard, getGemiBoardV3 } from '../../../lib/fetchers';
import { eliminateOjectNotTruthyValues } from '../../../lib/helperFuncs';
import { GemiBoardHeaderTitles, GemiBoardSubHeaderTitles, GemiBoardV3FPHeaderTitles, GemiBoardV3FPSubHeaderTitles, GemiBoardV3NPHeaderTitles, GemiBoardV3NPSubHeaderTitles } from '../../../lib/static/details/staticDetails';
import { GemiBoardAFMFields, GemiBoardV3Fields } from '../../../lib/static/filters/filterFields';
import { gemiBoardInitialValues, gemiBoardV3InitialValues } from '../../../lib/static/filters/initialValues';
import { gemiBoardV3ValidationSchema, gemiBoardValidationSchema } from '../../../lib/static/filters/ValidationSchema';
import Theme from '../../../Themes/main.theme';

const GemiBoard = () => {
  const [tab, setTab] = React.useState(0);
  const [data, setData] = React.useState();
  const [dataV3, setDataV3] = React.useState({fp: [], np: []});
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();

  const onSubmitArGemi = async (values: FormikConfig<any>) => {    
    setIsLoading(true);
    try {
      const response = await getGemiBoard(eliminateOjectNotTruthyValues(values));
      setError('');
      const data = response.data.boardMember.map((member: any) => {
        return {
          ...member,
          isRepresentativeAlone: member.isRepresentativeAlone
            ? 'ΝΑΙ'
            : 'ΟΧΙ',
          isRepresentativeInCommon: member.isRepresentativeInCommon
            ? 'ΝΑΙ'
            : 'ΟΧΙ'
        };
      }); 
      setData(data);
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };
  
  const onSubmitBoardV3 = async (values: FormikConfig<any>) => {        
    setIsLoading(true);    
    if (Object.values(values).filter(Boolean).length === 0) {      
      setError('Πρέπει να επιλέξετε τουλάχιστον ένα από τα πεδία ΑΦΜ, Αριθμός ΓΕΜΗ');
      setIsLoading(false);
      return;
    }    
    try {
      const response = await getGemiBoardV3(eliminateOjectNotTruthyValues(values));
      setError('');
      const data_fp = response.data.fp.map((member: any) => {
        return {
          ...member,
          isRepresentativeAlone: member.isRepresentativeAlone === 'true'
            ? 'ΝΑΙ'
            : 'ΟΧΙ',
          isRepresentativeInCommon: member.isRepresentativeInCommon === 'true'
            ? 'ΝΑΙ'
            : 'ΟΧΙ',
          activeMember: member.activeMember === 'true'
            ? 'ΝΑΙ'
            : 'ΟΧΙ'
        };
      });
      const data_np = response.data.np.map((member: any) => {
        return {
          ...member,
          isRepresentativeAlone: member.isRepresentativeAlone === 'true'
            ? 'ΝΑΙ'
            : 'ΟΧΙ',
          isRepresentativeInCommon: member.isRepresentativeInCommon === 'true'
            ? 'ΝΑΙ'
            : 'ΟΧΙ',
          activeMember: member.activeMember === 'true'
            ? 'ΝΑΙ'
            : 'ΟΧΙ'
        };
      });
      setDataV3({fp: data_fp, np: data_np});
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };
  

  const tabLabels = [
    {
      label: <Typography variant='h4'>Στοιχεία Διοικητικού Συμβουλίου Επιχείρησης</Typography>,
    },
    {
      label: <Typography variant='h4'>Στοιχεία μελών Διοικητικού Συμβουλίου και 
        Εκπροσώπων Επιχειρήσεων</Typography>,
    }
  ];

  const tab1 = <Box my={4} width='100%'>
    <FilterComponentV2
      title='Φίλτρο Αναζήτησης Στοιχείων Διοικητικού Συμβουλίου Επιχείρησης'
      validationSchema={gemiBoardValidationSchema}
      filterFields={GemiBoardAFMFields}
      initialValues={gemiBoardInitialValues}
      resetFilters={true}
      changeFilters={filterValues => onSubmitArGemi(filterValues)}
      validateOnBlur={false}
    />
    <Box mt={5}>
      {isLoading
        ? <Box sx={{ display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
        </Box>
        : error
          ? <Typography variant='h4' display='flex'
            justifyContent='center'>
            {error}
          </Typography> 
          : data
            ? <CollapsibleTable
              rows={data}
              headerTitles={GemiBoardHeaderTitles}
              subHeaderTitles={GemiBoardSubHeaderTitles}/>
            : null 
      }
    </Box>
  </Box>; 

  const tab2 = <Box my={4}>
    <FormHelperText sx={{mb: 1}}>
      <Typography variant='subtitle1'>
        <ul>
          <li>
            Η υπηρεσία αυτή αναζητάει και επιστρέφει στοιχεία μελών Διοικητικού 
            Συμβουλίου και εκπροσώπων επιχειρήσεων με βάση <span style={{fontWeight: 'bold'}}> τον αριθμό ΓΕΜΗ ή τον ΑΦΜ </span>της επιχείρησης
          </li>
          <li>
            Στην είσοδο είναι υποχρεωτικό να συμπληρωθεί από 
            <span style={{fontWeight: 'bold'}}> τουλάχιστον ένα</span> τα πεδία ΑΦΜ και Αριθμός ΓΕΜΗ.
          </li>
        </ul>
      </Typography>
    </FormHelperText>
    <FilterComponentV2
      title='Φίλτρο Αναζήτησης Στοιχείων Διοικητικού Συμβουλίου και Εκπροσώπων Επιχείρησης'
      validationSchema={gemiBoardV3ValidationSchema}
      filterFields={GemiBoardV3Fields}
      initialValues={gemiBoardV3InitialValues}
      resetFilters={true}
      changeFilters={filterValues => onSubmitBoardV3(filterValues)}
      validateOnBlur={false}
    />
    <Box mt={5}>
      {isLoading
        ? <Box sx={{ display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
        </Box>
        : error
          ? <Typography variant='h4' display='flex'
            justifyContent='center'>
            {error}
          </Typography> 
          : <>
            {dataV3?.fp?.length > 0
              ? <>
                <Typography mb={2} variant='h4'>Φυσικά Πρόσωπα</Typography>
                <CollapsibleTable
                  rows={dataV3.fp}
                  headerTitles={GemiBoardV3FPHeaderTitles}
                  subHeaderTitles={GemiBoardV3FPSubHeaderTitles}/>
              </> 
              : null
            }
            {dataV3?.np?.length > 0
              ? <>
                <Typography mt={4} mb={2}
                  variant='h4'>Νομικά Πρόσωπα</Typography>
                <CollapsibleTable
                  rows={dataV3.np}
                  headerTitles={GemiBoardV3NPHeaderTitles}
                  subHeaderTitles={GemiBoardV3NPSubHeaderTitles}/>
              </>
              : null
            }
          </> 
      }
    </Box>
  </Box>;
  const tabContent = [
    tab1,
    tab2
  ];

  return (
    <>
      <Box mt={5}>
        <Typography sx={{ my: 2 }} variant='h2'
          color={Theme?.labelColor?.main}>Μέλη Διοικητικού Συμβουλίου Επιχείρησης από 
          Μητρώο ΓΕΜΗ</Typography>
        <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />
        <TabsLayout
          tab={tab}
          setTab={setTab}
          tabLabels={tabLabels}
          tabContent={tabContent}
          resetFilters={() => {
            setData(undefined);
            setDataV3({fp: [], np: []});
            setError('');
          }}
        />
      </Box>
    </>
  );
};

export default GemiBoard;